<template>
  <div id="page-batch-print-label" class="container vs-con-loading__container">
    <div class="vx-row mt-10 mb-6">
      <div class="vx-col sm:w-1/3 w-full text-right">
        <span>Date*:</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full relative">
        <date-picker
          :appendToBody="false"
          v-model="form.date"
          label-placeholder="Date"
          placeholder="MM-DD-YYYY"
          format="MM-DD-YYYY"
          valueType="format"
          class="w-2/3 mb-1"
          name="Date"
          v-validate="'required'"
        />

        <span class="text-danger text-sm" v-show="errors.has('Date')">{{ errors.first('Date') }}</span>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full text-right">
        <span>Printer Type*:</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <select-2
          autocomplete
          class="w-2/3 mb-1"
          :value="form.printerType"
          @input="(item) => (form.printerType = item && item.value)"
          name="Printer Type"
          placeholder="Select Printer Type"
          :options="printerTypes"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Printer Type')">{{ errors.first('Printer Type') }}</span>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full text-right">
        <span>Label Size*:</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <select-2
          autocomplete
          class="w-2/3 mb-1"
          :value="form.labelSize"
          @input="(item) => (form.labelSize = item && item.value)"
          name="Label Size"
          placeholder="Select Label Size"
          :options="labelSizes"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Label Size')">{{ errors.first('Label Size') }}</span>
      </div>
    </div>
    <hr />
    <div class="vx-row mb-20">
      <div class="vx-col w-full">
        <div class="mt-4 text-center">
          <vs-button class="mt-2 mr-2" type="relief" @click="generateLabel" :disabled="!validateForm || loading"> Generate Labels </vs-button>
        </div>
      </div>
    </div>
    <print-pdf v-if="printLabel" :plants="plants" @close="close" :autoPrintPreview="true">
      <thermal-plants v-if="form.printerType === 'thermal_printer'" :plants="plants" :date="formatedDate" />
      <non-thermal-plants v-if="form.printerType === 'non_thermal_printer'" :plants="plants" :date="formatedDate" />
    </print-pdf>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import ThermalPlants from '@/views/batches/components/pdf/ThermalPlants.vue'
import NonThermalPlants from '@/views/batches/components/pdf/NonThermalPlants.vue'
import PrintPdf from '@/components/custom/PrintPdf.vue'
import { printerTypes, labelSizes } from '@/utils/batch-options'

export default {
  name: 'PrintLabel',
  data: () => ({
    form: {
      date: moment().format('MM-DD-YYYY'),
      printerType: '',
      labelSize: ''
    },
    plants: [],
    printLabel: false,
    loading: false,
    printerTypes,
    labelSizes
  }),
  computed: {
    validateForm() {
      return !this.errors.any()
    },
    formatedDate() {
      return moment(this.form.date).format('MM-DD-YYYY')
    }
  },
  methods: {
    ...mapActions('batch', ['getAllPlantsForPrintLabel']),
    async generateLabel() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Fill The Form',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
      this.loading = true

      try {
        const { data } = await this.getAllPlantsForPrintLabel(this.$route.params.id)
        this.loading = false
        this.$nextTick(() => {
          this.plants = data
        })
      } catch ({ message }) {
        this.loading = false
        this.$vs.notify({
          title: 'Error',
          text: 'Please Fill The Form',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      this.printLabel = true
    },
    close() {
      this.printLabel = false
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#page-batch-print-label',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#page-batch-print-label > .con-vs-loading')
      }
    }
  },
  components: {
    DatePicker,
    ThermalPlants,
    NonThermalPlants,
    PrintPdf,
    Select2
  }
}
</script>
